module.exports = __webpack_public_path__ + "img/human-cloning.f8de6322.jpg";